import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  constructor() {}

  getMaxSize = (): string => {
    return '5'; //MB
  };
  getMaxFiles = (): string => {
    return '5';
  };
  getAutorizedFileExtensions = (): string[] => {
    //https://www.w3schools.com/TAGS/att_input_accept.asp#:~:text=HTML%20%3Cinput%3E%20accept%20Attribute%201%20Definition%20and%20Usage,...%204%20Attribute%20Values%20%E2%9D%AE%20HTML%20%3Cinput%3E%20tag
    return [
      '.jpg',
      '.jpeg',
      '.png',
      '.pdf',
      '.msg',
      '.tiff',
      '.docx',
      '.eml',
      '.doc',
      '.webp',
    ];
  };

  getAvatarMaxSize = (): string => {
    return '3'; //Mb
  };

  //generic
  getGenericAutorizedFileExtensions = (): string[] => {
    return [
      '.jpg',
      '.jpeg',
      '.png',
      '.pdf',
      '.msg',
      '.tiff',
      '.docx',
      '.eml',
      '.doc',
      '.webp',
    ];
  };
  getGenericMaxSize = (): string => {
    return '5'; //Mb
  };

  //open directly
  getOpenFileExtensions = (): string[] => {
    return ['.jpg', '.jpeg', '.png', '.pdf', '.webp'];
  };

  //For reject reason
  getRejectReasonMaxLength = (): number => {
    return 500;
  };
}

export type ConfigKey =
  | 'MaxSize'
  | 'MaxFiles'
  | 'AutorizedFileExtensions'
  | 'AvatarMaxSize'
  | 'GenericMaxSize'
  | 'GenericAutorizedFileExtensions'
  | 'OpenFileExtensions';
